import './ListiclePOIs.css';
import React from 'react';
import { parse } from 'node-html-parser';
import { get, getGlobalDictionaryTerm, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as IconLocation } from '../../resources/icons/ReskinIconPin.svg';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { commonStyles as commonComponentStyles, rtlStyles, ltrStyles } from '../77_ListicleItem/ListicleItem';
import { truncateStyles } from '../77_ListicleEvents/ListicleEvents';
import RouterLink from '../atoms/RouterLink';
// import Truncate from 'react-truncate';
import TruncateMarkup from 'react-truncate-markup';
import ReactHtmlParser from 'react-html-parser';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/IconChevronRightLight.svg';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import { renderRTListSchema, getListsTexts } from '../../utils/seo';
export const ListiclePOIs = _ref => {
  let {
    fields,
    index,
    readmore,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const businessSite = get(sitecoreContext, 'site.name') === 'business';
  const moduleId = get(fields, 'data.item.id');
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const infoRef = React.useRef(null);
  const [truncateWidth, settruncateWidth] = React.useState(1100);
  const enablingReadMore = get(fields, 'data.item.enablingReadMore.jss.value');
  const [isTruncated, setisTruncated] = React.useState(enablingReadMore);
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const dictionaryValues = get(fields, 'data.moduleDictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [componentListsSchema, setComponentListsSchema] = React.useState([]);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  React.useEffect(() => {
    if (truncateWidth < 769) {
      setisTruncated(true);
    }
  }, [truncateWidth]);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const variables = ColorHex ? {
    "--m77-listicle-pois-background-color": BackgroundColorHex,
    "--m77-listicle-pois-color": ColorHex
  } : {
    "--m77-listicle-pois-background-color": selectedPrimaryColor,
    "--m77-listicle-pois-color": getColorByTheme(selectedPrimaryColor)
  };
  React.useEffect(() => {
    setTimeout(() => {
      if (infoRef.current) {
        settruncateWidth(infoRef.current.offsetWidth);
      }
    }, 1000);
  }, [fields]);
  const itemTitle = get(fields, 'data.item.title.jss.value');
  const targetUrl = get(fields, 'data.item.url');
  const number = get(fields, 'data.item.number.jss');
  const hasFallbackImage = Boolean(get(fields, 'data.item.fallbackImage.jss.value.src'));
  const itemFallbackImage = get(fields, 'data.item.fallbackImage.jss.value.src') || '';
  const itemFallbackImageCaption = get(fields, 'data.item.fallbackImage.jss.value.alt');
  const itemIntroText = Boolean(get(fields, 'data.item.introText.jss.value'));

  //const hasVideoSrc: boolean = Boolean(get(fields, 'data.item.media.jss.value.href'));
  let videoSrc = get(fields, 'data.item.media.jss.value.href');
  const videoType = get(fields, 'data.item.media.jss.value.linktype');
  if (videoSrc === 'http://' || videoSrc === 'https://') {
    videoSrc = '';
  }
  const itemCategory = Boolean(get(fields, 'data.item.category.value.title.jss.value'));
  const GooglePlaceID = get(fields, 'data.item.googlePlaceID.jss.value');
  const googleMapUrl = 'https://www.google.com/maps/place/?q=place_id:';
  const GooglePlaceIDUrl = googleMapUrl + GooglePlaceID;
  const intro = get(fields, 'data.item.intro.jss') || get(fields, 'data.item.extendedIntroText.jss');
  const address = get(fields, 'data.item.address.jss.value');
  const {
    videoAnalytics,
    readMoreAnalytics
  } = fields.data;
  React.useEffect(() => {
    const dom = intro ? parse(intro.value) : undefined;
    const rtLists = getListsTexts(dom);
    if (rtLists.length) setComponentListsSchema(rtLists);
  }, []);
  if (!fields) {
    console.warn('ListicleItemPOI component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[ListicleItemPOI component is empty: please provide datasource]");
    }
    return null;
  }
  const renderMedia = () => {
    if (!hasFallbackImage) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "listicle__media-outer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "listicle__media-inner listicle__media-inner--poster-show"
    }, /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true,
      className: "listicle__image-box"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width:1200px)",
      srcSet: `${itemFallbackImage}&cw=1420&ch=710`
    }), /*#__PURE__*/React.createElement("source", {
      media: "(min-width:769px)",
      srcSet: `${itemFallbackImage}&cw=1180&ch=590`
    }), /*#__PURE__*/React.createElement("source", {
      media: "(max-width:768px)",
      srcSet: `${itemFallbackImage}&cw=325&ch=243`
    }), /*#__PURE__*/React.createElement("img", {
      src: `${itemFallbackImage}&cw=1420&ch=710`,
      className: "listicle__img",
      alt: `${itemFallbackImageCaption}`
    })), videoSrc && /*#__PURE__*/React.createElement(Video, {
      buttonTopAlignment: true,
      className: "media-wrapper__video",
      videoType: videoType,
      videoSrc: videoSrc,
      click: e => tealiumClickFunc(tealiumMergeClickData(videoAnalytics, params), [e, getLastPartInURL(videoSrc)])
    }), /*#__PURE__*/React.createElement(FavouriteBtn, {
      itemId: moduleId,
      classes: ' listicle__fav-btn'
    }))), /*#__PURE__*/React.createElement("div", {
      className: "listicle__caption body-small"
    }));
  };
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__item"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    className: `listicle__tag ${businessSite ? 'listicle__tag--business' : ''}`,
    field: number,
    "data-cy": "number"
  }), index && /*#__PURE__*/React.createElement("div", {
    className: `listicle__tag ${businessSite ? 'listicle__tag--business' : ''}`
  }, index), itemIntroText && /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "h2 listicle__title",
    editable: false,
    field: fields.data.item.introText.jss,
    "data-cy": "listicle__title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "listicle__media"
  }, renderMedia()), /*#__PURE__*/React.createElement("div", {
    className: `listicle__info ${itemFallbackImageCaption && 'listicle__info--no-caption'}`
  }, /*#__PURE__*/React.createElement("div", {
    ref: infoRef,
    className: "listicle__info-text"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: `${truncateWidth}px`
    }
  }, isTruncated ? /*#__PURE__*/React.createElement("div", {
    className: "truncated-copy"
  }, /*#__PURE__*/React.createElement(TruncateMarkup, {
    lines: 3,
    ellipsis: /*#__PURE__*/React.createElement("span", {
      className: "read-more"
    }, `... `, /*#__PURE__*/React.createElement("b", {
      tabIndex: 0,
      onKeyPress: event => {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      },
      onClick: () => {
        setisTruncated(false);
        tealiumClickFunc(tealiumMergeClickData(readMoreAnalytics, params), [getLastPartInURL(fields.data.item.introText.jss.value)]);
      },
      className: ""
    }, mapDictionary.get('ReadMore') || readmore, /*#__PURE__*/React.createElement(IconChevronRightLight, null)))
  }, /*#__PURE__*/React.createElement("div", null, ReactHtmlParser(intro && intro.value)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, ReactHtmlParser(intro && intro.value)))))), /*#__PURE__*/React.createElement("div", {
    className: "listicle__bottom-info"
  }, itemTitle && /*#__PURE__*/React.createElement(RouterLink, {
    href: targetUrl,
    title: `${itemTitle}`,
    "data-cy": "listicle__item-link",
    className: "listicle__item-link body-large listicle__bottom-title"
  }, itemTitle), itemCategory && /*#__PURE__*/React.createElement("div", {
    className: "listicle__bottom-small"
  }, fields.data.item.category.value.title.jss.value), /*#__PURE__*/React.createElement("ul", {
    className: "listicle__list"
  }, address && /*#__PURE__*/React.createElement("li", {
    className: "listicle__list-item"
  }, GooglePlaceID ? /*#__PURE__*/React.createElement("a", {
    href: `${GooglePlaceIDUrl}`,
    target: "_blank",
    rel: "noopener noreferrer",
    title: `${address} | ${newWindowLabel}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconLocation, null)), /*#__PURE__*/React.createElement("span", {
    className: "listicle__tag-text"
  }, address)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconLocation, null)), /*#__PURE__*/React.createElement("span", {
    className: "listicle__tag-text"
  }, address))))))), componentListsSchema.map(listSchema => renderRTListSchema(listSchema)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonComponentStyles} ${commonStyles} ${truncateStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1cyntbp";
export default ListiclePOIs;